
import React from "react";

import FileUploadList from "../component/FileUploadList";

const FileUploadListContainer = ({ pageId }) => (<FileUploadList pageId={ pageId } />)

export default FileUploadListContainer; 